import { get as _get } from '../common';
import { pageNames } from '@atc/bonnet-paths';

const getServiceTabFromState = (state) => {
    const enableServiceTab = _get(state, `domain.${pageNames.DEALER_DETAILS}.enableServiceTab`, '');
    return enableServiceTab === 'true';
};
export default getServiceTabFromState;
